import { inject, Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Router } from '@angular/router';
import { JwtService } from '../services/jwt.service';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    jwtService=inject(JwtService);
    authService=inject(AuthService);
  constructor() {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(
    // map(el=>{console.log(el);return el}),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          console.warn('Token scaduto o non autorizzato');

          // Pulisce lo stato e i cookie
          this.jwtService.unset();
            localStorage.clear()
          // Reindirizza eventualmente al login
            this.authService.login()

          // Puoi anche emettere un messaggio utente, se vuoi
        }

        return throwError(() => error);
      })
    );
  }
}
